import React, { Component } from "react";
import axios from "axios";
import { Modal, Form, Button } from "react-bootstrap";
import { BASE_URL, HEADERS } from "../../common/api";
import PromoCodeTable from "../../assets/js/CodeTable";

const columns = [
  { field: "code", header: "Код" },
  { field: "discount_display", header: "Скидка" },
  { field: "max_uses", header: "Лимит" },
  { field: "used_count", header: "Использовано" },
  { field: "remaining_uses", header: "Осталось" },
  { field: "is_active", header: "Активен" },
  { field: "is_register_promo_code", header: "Реистрационный промокод" },
  { field: "valid_from", header: "С" },
  { field: "valid_until", header: "До" },
];

class PromoCodeAdmin extends Component {
  state = {
    data: [],
    loading: true,
    error: null,

    showModal: false,
    isEdit: false,
    currentId: null,

    form: {
      code: "",
      auto_generate_code: false,
      discount_type: "percent",
      discount_value: "",
      max_uses: 1,
      valid_from: "",
      valid_until: "",
      is_active: true,
      is_register_promo_code: false,
      description: "",
    },
  };

  componentDidMount() {
    this.fetchPromoCodes();
  }

  // ======================
  // API
  // ======================
  fetchPromoCodes = () => {
    axios
      .get(BASE_URL + "promo-codes/", HEADERS)
      .then((res) => {
        this.setState({ data: res.data, loading: false });
      })
      .catch(() => {
        this.setState({
          error: "Не удалось загрузить промокоды",
          loading: false,
        });
      });
  };

  fetchOne = (id) => {
    axios
      .get(BASE_URL + `promo-codes/${id}/`, HEADERS)
      .then((res) => {
        this.setState({
          form: {
            ...res.data,
            auto_generate_code: false,
          },
          showModal: true,
          isEdit: true,
          currentId: id,
        });
      });
  };

  // ======================
  // MODAL
  // ======================
  openCreateModal = () => {
    this.setState({
      showModal: true,
      isEdit: false,
      currentId: null,
      form: {
        code: "",
        auto_generate_code: false,
        discount_type: "percent",
        discount_value: "",
        max_uses: 1,
        valid_from: "",
        valid_until: "",
        is_active: true, 
        is_register_promo_code: false,  
        description: "",
      },
    });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  // ======================
  // FORM
  // ======================
  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      form: {
        ...this.state.form,
        [name]: type === "checkbox" ? checked : value,
      },
    });
  };

  handleSubmit = () => {
    const { isEdit, currentId, form } = this.state;

    if (!form.auto_generate_code && !form.code?.trim()) {
      alert("Введите код промокода");
      return;
    }
    if (
      form.discount_type === "percent" &&
      Number(form.discount_value) > 100
    ) {
      alert("Процентная скидка не может быть больше 100%");
      return;
    }
  
    if (
      form.discount_type === "fixed" &&
      Number(form.discount_value) > 100_000
    ) {
      alert("Фиксированная скидка не может быть больше 100000");
      return;
    }

    if (!form.valid_from) {
      alert("Укажите дату и время начала действия");
      return;
    }


    const payload = form.auto_generate_code
      ? {
          auto_generate_code: true,
          discount_type: form.discount_type,
          discount_value: form.discount_value,
          max_uses: form.max_uses,
          valid_from: form.valid_from,
          valid_until: form.valid_until || null,
          is_active: form.is_active,
          is_register_promo_code: form.is_register_promo_code,
          description: form.description,
        }
      : {
          code: form.code.toUpperCase(),
          discount_type: form.discount_type,
          discount_value: form.discount_value,
          max_uses: form.max_uses,
          valid_from: form.valid_from,
          valid_until: form.valid_until || null,
          is_active: form.is_active,
          is_register_promo_code: form.is_register_promo_code,
          description: form.description,
        };
      
    const request = isEdit
      ? axios.put(BASE_URL + `promo-codes/${currentId}/`, payload, HEADERS)
      : axios.post(BASE_URL + "promo-codes/", payload, HEADERS);

    request.then(() => {
      this.closeModal();
      this.fetchPromoCodes();
    });
  };

  // ======================
  // DELETE
  // ======================
  handleDelete = (row) => {
    if (!window.confirm(`Удалить промокод ${row.code}?`)) return;

    axios
      .delete(BASE_URL + `promo-codes/${row.id}/`, HEADERS)
      .then(() => this.fetchPromoCodes())
      .catch((err) => {
        if (err.response?.data?.error) {
          alert(
            `${err.response.data.error}\nИспользовано: ${err.response.data.used_count}`
          );
        } else {
          alert("Ошибка удаления");
        }
      });
  };

  // ======================
  // RENDER
  // ======================

  render() {
    const { data, loading, error, showModal, form, isEdit } = this.state;
    console.log(form);
    
    if (loading) return <div className="p-5 text-center">Загрузка...</div>;
    if (error) return <div className="alert alert-danger">{error}</div>;

    return (
      <div className="container-fluid p-4">
        <Button variant="success" className="mb-3" onClick={this.openCreateModal}>
          ➕ Создать промокод
        </Button>

        <PromoCodeTable
          data={data}
          columns={columns}
          title="Промокоды"
          onEdit={(row) => this.fetchOne(row.id)}
          onDelete={this.handleDelete}
        />

        {/* MODAL */}
        <Modal show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {isEdit ? "Редактирование промокода" : "Создание промокода"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form>
              {!isEdit && (
                <Form.Check
                  type="checkbox"
                  label="Авто генерация кода"
                  name="auto_generate_code"
                  checked={form.auto_generate_code}
                  onChange={this.handleChange}
                />
              )}

              {!form.auto_generate_code && (
                <Form.Group>
                  <Form.Label>Код</Form.Label>
                  <Form.Control
                    name="code"
                    value={form.code}
                    onChange={this.handleChange}
                    required
                  />
                </Form.Group>
              )}

              <Form.Group>
                <Form.Label>Тип скидки</Form.Label>
                <Form.Control
                  as="select"
                  name="discount_type"
                  value={form.discount_type}
                  onChange={this.handleChange}
                >
                  <option value="percent">Процент</option>
                  <option value="fixed">Фиксированная</option>
                </Form.Control>
              </Form.Group>

              <Form.Group>
                <Form.Label>Значение</Form.Label>
                <Form.Control
                  name="discount_value"
                  type="number"
                  value={form.discount_value}
                  onChange={this.handleChange}
                  required
                  min={0}
                  max={form.discount_type === "percent" ? 100 : 100000}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Лимит использований</Form.Label>
                <Form.Control
                  name="max_uses"
                  type="number"
                  value={form.max_uses}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Действует с</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="valid_from"
                  value={form.valid_from}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Действует до</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="valid_until"
                  value={form.valid_until || ""}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Check
                type="checkbox"
                label="Активен"
                name="is_active"
                checked={form.is_active}
                onChange={this.handleChange}
              />
              <Form.Check
                type="checkbox"
                label="Реистрационный промокод"
                name="is_register_promo_code"
                checked={form.is_register_promo_code}
                onChange={this.handleChange}
              />

              <Form.Group>
                <Form.Label>Описание</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={form.description}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Отмена
            </Button>
            <Button variant="primary" onClick={this.handleSubmit}>
              Сохранить
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PromoCodeAdmin;
